<template>
  <RecordViewWrapper>
    <sdPageHeader title="Rekap Kinerja Organisasi" />
    <Main>
      <a-row :gutter="25">
        <a-col :span="24">
          <sdCards headless>
            <a-row :gutter="16">
              <a-col :md="6" :sm="24">
                <a-select
                  placeholder="Pilih Bulan"
                  style="width: 100%"
                  v-model:value="filters.bulan"
                  @change="refreshData"
                >
                  <a-select-option v-for="bulan in months" :key="bulan.index">
                    {{ bulan.full }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-select
                  placeholder="Pilih Tahun"
                  style="width: 100%"
                  v-model:value="filters.tahun"
                  @change="refreshData"
                >
                  <a-select-option v-for="tahun in tahunOptions" :key="tahun" :value="tahun">
                    {{ tahun }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-select
                  placeholder="Pilih Entitas"
                  style="width: 100%"
                  v-model:value="filters.entitas"
                  @change="refreshData"
                >
                  <a-select-option v-for="entitas in options.entitas" :key="entitas.value">
                    {{ entitas.text }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :md="6" :sm="24" style="text-align: right;">
                <a-button type="primary" @click="refreshData" style="margin-right: 5px;">
                  <template #icon><ReloadOutlined /></template>
                  Refresh Data</a-button
                >
                <a-dropdown-button type="primary" :loading="loadingExport">
                  <template #icon><DownloadOutlined /></template>
                  Export Excel
                  <template #overlay>
                    <a-menu>
                      <a-menu-item key="selfExcel" @click="exportData('self')">
                        Self Assessment
                      </a-menu-item>
                      <a-menu-item key="verifExcel" @click="exportData('verifikasi')">
                        Verifikasi
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown-button>
                <a-dropdown-button type="primary" :loading="loadingExportPdf" style="margin-left: 5px;">
                  <template #icon><DownloadOutlined /></template>
                  Export PDF
                  <template #overlay>
                    <a-menu>
                      <a-menu-item key="selfPdf" @click="exportDataPdf('self')">
                        Self Assessment
                      </a-menu-item>
                      <a-menu-item key="verifPdf" @click="exportDataPdf('verifikasi')">
                        Verifikasi
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown-button>
              </a-col>
            </a-row>
          </sdCards>
        </a-col>
      </a-row>

      <!-- Rekap Table Section -->
      <a-row :gutter="25">
        <a-col :span="24">
          <sdCards title="Rekap Kinerja" bodypadding="0px">
            <!-- <div v-if="isLoading" class="spin">
              <a-spin />
            </div>
            <div v-else> -->
            <a-table
              :columns="rekapColumns"
              :dataSource="dataSource"
              :row-class-name="rowClassName"
              :pagination="false"
              :scroll="{ x: 2000, y: 400 }"
              :loading="isLoading"
              bordered
            />
            <!-- </div> -->
          </sdCards>
        </a-col>
      </a-row>

      <a-row :gutter="25">
        <a-col :span="24">
          <sdCards headless bodypadding="0px">
            <div v-if="isLoading"></div>
            <div v-else>
              <a-row>
                <a-col span="8">
                  <span>Status : </span>
                  <a-tag style="margin-left: 10px;" :color="getStatusApprovalColor(approvalStatus)">{{
                    approvalStatus
                  }}</a-tag>
                </a-col>
                <a-col span="8" style="display: flex; align-items: center;">
                  <span>Evidence File : </span>
                  <a-progress
                    v-if="isDownload"
                    :value="downloadProgress"
                    :percent="downloadProgress"
                    style="margin-left: 10px;"
                  />
                  <a-button v-if="file && !isDownload" type="link" @click="download(file)">{{ filename }}</a-button>
                  <a-button
                    v-if="file && !isDownload && approvalStatus != 'Approved'"
                    type="link"
                    @click="handleDeleteEvidence"
                    ><DeleteOutlined style="font-size: 24px;"
                  /></a-button>
                </a-col>
                <a-col span="8" style="display: flex; align-items: center; justify-content: flex-end;">
                  <div>
                    <a-button
                      v-if="
                        profile.entitas_id == filters.entitas &&
                          canManageApproval &&
                          isApproveVisible &&
                          dataSource.length > 0
                      "
                      ype="primary"
                      @click="uploadEvidence"
                      style="margin-right: 10px;"
                    >
                      <template #icon><UploadOutlined /></template>
                      Upload Evidence</a-button
                    >
                    <a-button
                      v-if="
                        profile.entitas_id == filters.entitas &&
                          canManageApproval &&
                          isApproveVisible &&
                          dataSource.length > 0
                      "
                      type="primary"
                      @click="saveAndApprove"
                    >
                      {{ checkPermission('send for approval') ? 'Send for Approval' : 'Approve' }}
                    </a-button>
                  </div>
                </a-col>
              </a-row>
            </div>
          </sdCards>
        </a-col>
      </a-row>
      <!-- Action Buttons -->
    </Main>
  </RecordViewWrapper>
</template>

<script>
import { RecordViewWrapper } from '../../../components/crud/style';
import { Main } from '../../styled';
import { useStore } from 'vuex';
import { useRouter, onBeforeRouteLeave } from 'vue-router';
import { getItem, setItem } from '@/utility/localStorageControl';
import axiosApi from '@/api';
import { exportFile } from '@/utility/exportUtils';
import { checkStatusApproval as checkStatusApprovalUtil } from '@/utility/approvalStatus';
import { UploadOutlined, DownloadOutlined, DeleteOutlined, ReloadOutlined } from '@ant-design/icons-vue';
import { ref, reactive, onMounted, computed, h } from 'vue';
import { notification, Modal, Space } from 'ant-design-vue';
import { renderAvatar } from '@/utility/renderComponents';
import { getItemFlags } from '@/utility/rekap/getItemFlags';
import { getStyleFlags } from '@/utility/rekap/getStyleFlags';
import { getVerifikasiFlags } from '@/utility/rekap/getVerifikasiFlags';
import { polarisasiIcon } from '@/utility/polarisasiUtils';

export default {
  name: 'NkoRekap',
  components: {
    Main,
    RecordViewWrapper,
    UploadOutlined,
    DownloadOutlined,
    DeleteOutlined,
    ReloadOutlined,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { state, dispatch } = useStore();
    const crud = computed(() => state.crud.data);

    const isLoading = computed(() => state.crud.loading);
    const profile = getItem('profile_plnbb');
    const permissions = getItem('permissions');
    const accessToken = getItem('access_token');
    const entitas = getItem('entitas');
    const tahun = getItem('tahun');
    const bulan = getItem('bulan');
    const approvalStatus = ref('');
    const isApproveVisible = ref(false);
    const file = ref(null);
    const filename = ref('');
    const loadingExport = ref(false);
    const loadingExportPdf = ref(false);
    const downloadProgress = ref(0);
    const isDownload = ref(false);

    // Filter options
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const tahunOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

    const filters = reactive({
      bulan: bulan ? bulan : currentMonth,
      tahun: tahun ? tahun : currentYear,
      entitas: entitas ? entitas : null,
      title: 'Kontrak Kinerja Organisasi',
    });

    const options = reactive({
      entitas: [],
    });

    // Using global months data from utility
    const { months } = require('@/utility/monthsData');

    const rekapColumns = ref([
      {
        title: '#',
        dataIndex: 'number',
        key: 'number',
        width: 100,
        align: 'center',
      },
      {
        title: 'Indikator',
        dataIndex: 'name',
        key: 'name',
        width: 300,
        align: 'center',
      },
      {
        title: '',
        dataIndex: 'polarisasi',
        key: 'polarisasi',
        width: 50,
        align: 'center',
        customRender: ({ text }) => {
          return polarisasiIcon(text);
        },
      },
      {
        title: 'Satuan',
        dataIndex: 'satuan_kpi_id',
        key: 'satuan_kpi_id',
        width: 100,
      },
      {
        title: 'Bobot',
        dataIndex: 'bobot',
        key: 'bobot',
        width: 150,
        align: 'center',
      },
      {
        title: 'Target KM',
        dataIndex: 'target_tahunan',
        key: 'target_tahunan',
        width: 150,
        align: 'center',
        customRender: ({ text }) => {
          return h(
            'div',
            {
              style: {
                whiteSpace: 'pre-line',
                lineHeight: '1.5',
                padding: '8px',
                minHeight: '40px', // untuk kesamaan tinggi minimal
              },
            },
            text,
          );
        },
      },
      {
        title: 'Target Bulan',
        dataIndex: 'target',
        key: 'target',
        width: 150,
        align: 'center',
        customRender: ({ text }) => {
          return h(
            'div',
            {
              style: {
                whiteSpace: 'pre-line',
                lineHeight: '1.5',
                padding: '8px',
                minHeight: '40px', // untuk kesamaan tinggi minimal
              },
            },
            text,
          );
        },
        customCell: record => {
          if (record.is_parent) {
            return {
              style: {
                backgroundColor: '#FADA7A',
              },
            };
          }
          return {
            style: {
              backgroundColor: !record.target && !record.is_parent ? '#f5f5f5' : '#FFFFFF',
            },
          };
        },
      },
      {
        title: 'Realisasi Bulan ',
        dataIndex: 'realisasi',
        key: 'realisasi',
        width: 150,
        align: 'center',
        colSpan: 2,
        customRender: ({ text }) => {
          return h(
            'div',
            {
              style: {
                whiteSpace: 'pre-line',
                lineHeight: '1.5',
                padding: '8px',
                minHeight: '40px', // untuk kesamaan tinggi minimal
              },
            },
            text,
          );
        },
      },
      {
        title: '',
        key: 'action_realisasi',
        width: 100,
        align: 'center',
        colSpan: 0,
        customRender: ({ record }) => {
          const { createRealisasi, updateRealisasi, del, realisasiStatus } = getItemFlags(
            record,
            profile,
            filters,
            checkPermission,
            handleDeleteRealisasi,
          );
          return h(Space, { direction: 'horizontal', size: '0' }, [
            createRealisasi,
            updateRealisasi,
            del,
            h(Space, { direction: 'vertical', size: '0' }, [realisasiStatus]),
          ]);
        },
      },
      {
        title: 'Pencapaian',
        dataIndex: 'pencapaian',
        key: 'pencapaian',
        width: 100,
        align: 'center',
      },
      {
        title: 'Nilai',
        dataIndex: 'nilai',
        key: 'nilai',
        width: 85,
        align: 'center',
      },
      {
        title: 'Keterangan',
        dataIndex: 'keterangan',
        key: 'keterangan',
        align: 'center',
        width: 150,
        customRender: ({ text }) => {
          return renderAvatar(text);
        },
      },
      {
        title: 'Penyebab Tidak Tercapai/Tercapai',
        dataIndex: 'penjelasan',
        key: 'penjelasan',
        width: 400,
        customRender: ({ text }) => {
          return h('div', { style: { whiteSpace: 'pre-line' } }, text);
        },
      },
      {
        title: 'Action Plan',
        dataIndex: 'action_plan',
        key: 'action_plan',
        width: 400,
        customRender: ({ text }) => {
          return h('div', { style: { whiteSpace: 'pre-line' } }, text);
        },
      },
      {
        title: 'Verifikasi PIC Kinerja EPI',
        children: [
          {
            title: 'Target Bulan ',
            dataIndex: 'target',
            key: 'target',
            width: 150,
            align: 'center',
            customRender: ({ text }) => {
              return h('div', { style: { whiteSpace: 'pre-line' } }, text);
            },
          },
          {
            title: 'Realisasi Bulan ',
            dataIndex: 'verifikasi',
            key: 'verifikasi',
            width: 150,
            align: 'center',
            colSpan: 2,
            customRender: ({ text }) => {
              return h('div', { style: { whiteSpace: 'pre-line' } }, text);
            },
          },
          {
            title: '',
            dataIndex: 'action_verifikasi',
            key: 'action_verifikasi',
            width: 100,
            align: 'center',
            colSpan: 0,
            customRender: ({ record }) => {
              const { createVerifikasi, updateVerifikasi, delVerifikasi, vrealisasiStatus } = getVerifikasiFlags(
                record,
                profile,
                filters,
                checkPermission,
                handleDeleteVerifikasi,
              );
              return h(Space, { direction: 'horizontal', size: '0' }, [
                createVerifikasi,
                updateVerifikasi,
                delVerifikasi,
                h(Space, { direction: 'vertical', size: '0' }, [vrealisasiStatus]),
              ]);
            },
          },
          {
            title: 'Pencapaian',
            dataIndex: 'verifikasiPencapaian',
            key: 'verifikasiPencapaian',
            width: 150,
          },
          {
            title: 'Nilai',
            dataIndex: 'verifikasiN',
            key: 'verifikasiN',
            width: 150,
          },
          {
            title: 'Keterangan',
            dataIndex: 'verifikasiKet',
            key: 'verifikasiKet',
            width: 150,
            customRender: ({ text }) => {
              return renderAvatar(text);
            },
          },
        ],
      },
    ]);

    const formatNumber = val => {
      if (!val) return '';
      if (isNaN(val)) return val;
      if (val < 0) return '(' + Math.abs(val).toFixed(2) + ')';
      return Number(val).toFixed(2); // "1234.57"
    };

    const checkPermission = permission => {
      if (profile.roles[0].name == 'Super Admin') {
        return true;
      }

      return permissions.includes(permission);
    };

    const canManageApproval = computed(
      () => checkPermission('send for approval') || checkPermission('approve realisasi kpi korporat'),
    );

    // Function to refresh data
    const refreshData = () => {
      rekapColumns.value[6].title = 'Target Bulan ' + months[filters.bulan - 1].short;
      rekapColumns.value[7].title = 'Realisasi Bulan ' + months[filters.bulan - 1].short;
      rekapColumns.value[14].children[0].title = 'Target Bulan ' + months[filters.bulan - 1].short;
      rekapColumns.value[14].children[1].title = 'Realisasi Bulan ' + months[filters.bulan - 1].short;
      setItem('entitas', filters.entitas);
      setItem('tahun', filters.tahun);
      setItem('bulan', filters.bulan);
      store.commit('axiosResetState');
      setTimeout(() => {
        getData(filters.entitas, filters.tahun, filters.bulan);
        getStatusApproval(filters.entitas, filters.tahun, filters.bulan);
        checkStatusApproval(approvalStatus.value);
      }, 100);
    };

    // getVerifikasiFlags function has been moved to a separate utility file

    const dataSource = computed(() => {
      if (crud.value.length == 0) return [];
      return crud.value.map((item, index) => {
        const { isPengurang, isNKO } = getItemFlags(item, profile, filters, checkPermission);

        const { keterangan, vketerangan } = getStyleFlags(item, isPengurang, isNKO);

        return {
          key: item.id || index,
          number: item.number,
          name: item.name,
          is_parent: item.is_parent,
          starting_month: item.starting_month,
          vrealisasi: item.vrealisasi,
          vrealisasi_id: item.vrealisasi_id,
          realisasi_status: item.realisasi_status,
          vrealisasi_status: item.vrealisasi_status,
          jenis_variable_kpi_id: item.jenis_variable_kpi_id,
          kpi_id: item.id,
          realisasi_id: item.realisasi_id,
          polarisasi: item.polarisasi,
          satuan_kpi_id: item.satuan_kpi ? item.satuan_kpi.name : null,
          bobot: item.jenis_variable_kpi_id == 3 ? 'Max - ' + item.max_pengurang : formatNumber(item.bobot),
          target_tahunan: formatNumber(item.target_km),
          target: formatNumber(item.target),
          realisasi: formatNumber(item.realisasi),
          pencapaian: item.pencapaian ? formatNumber(item.pencapaian) + ' %' : null,
          nilai: formatNumber(item.nilai),
          verifikasi: formatNumber(item.vrealisasi),
          verifikasiPencapaian: formatNumber(item.vpencapaian),
          verifikasiN: formatNumber(item.vnilai),
          verifikasiKet: vketerangan,
          keterangan: keterangan,
          penjelasan: item.penjelasan,
          action_plan: item.action_plan,
        };
      });
    });

    const getData = (entitas_id, tahun, bulan) => {
      dispatch(
        'axiosCrudGetData',
        'list-realisasi-nko?month=' + bulan + '&year=' + tahun + '&entitas_id=' + entitas_id,
      );
    };

    const handleDeleteRealisasi = (id, name, bulan, tahun) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin menghapus realisasi ${name} bulan ${months[bulan - 1].full} tahun ${tahun}?`,
        okText: 'Hapus',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataDelete', {
            id,
            url: 'realisasi-nko',
            getData: () => {
              dispatch(
                'axiosCrudGetData',
                'list-realisasi-nko?month=' + bulan + '&year=' + tahun + '&entitas_id=' + entitas,
              );
            },
          });
        },
      });
    };

    const handleDeleteVerifikasi = (id, name, bulan, tahun) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin menghapus verifikasi ${name} bulan ${months[bulan - 1].full} tahun ${tahun}?`,
        okText: 'Hapus',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataDelete', {
            id,
            url: 'verifikasi-realisasi-kpi',
            getData: () => {
              dispatch(
                'axiosCrudGetData',
                'list-realisasi-nko?month=' + bulan + '&year=' + tahun + '&entitas_id=' + entitas,
              );
            },
          });
        },
      });
    };

    // Evidence Modal
    const evidenceModal = reactive({
      visible: false,
      fileList: [],
    });

    const uploadEvidence = () => {
      router.push('/nko-rekap-upload');
    };

    const beforeUpload = file => {
      evidenceModal.fileList = [...evidenceModal.fileList, file];
      return false;
    };

    const handleRemove = file => {
      const index = evidenceModal.fileList.indexOf(file);
      const newFileList = evidenceModal.fileList.slice();
      newFileList.splice(index, 1);
      evidenceModal.fileList = newFileList;
    };

    const handleEvidenceOk = () => {
      // Process file upload here
      console.log('Files to upload:', evidenceModal.fileList);
      evidenceModal.visible = false;
    };

    const handleEvidenceCancel = () => {
      evidenceModal.visible = false;
    };

    // Function to save and approve
    const saveAndApprove = () => {
      console.log('Saving and approving data');
      Modal.confirm({
        title: 'Konfirmasi',
        content: checkPermission('send for approval')
          ? `Apakah Anda yakin ingin melakukan Save realisasi bulan ${months[filters.bulan - 1].full} ${filters.tahun}?`
          : `Apakah Anda yakin ingin melakukan Approve realisasi bulan ${months[filters.bulan - 1].full} ${
              filters.tahun
            }?`,
        okText: checkPermission('send for approval') ? 'Save' : 'Approve',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosApprove', {
            data: {
              entitas_id: filters.entitas,
              years: filters.tahun,
              month: filters.bulan,
            },
            url: 'realisasi-approval',
            getData: () => {
              getData(filters.entitas, filters.tahun, filters.bulan);
              getStatusApproval(filters.entitas, filters.tahun, filters.bulan);
            },
          });
        },
      });
    };

    const handleDeleteEvidence = () => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin menghapus evidence bulan ${months[filters.bulan - 1].full} ${filters.tahun}?`,
        okText: 'Hapus',
        cancelText: 'Batal',
        onOk: () => {
          deleteEvidence();
        },
      });
    };

    const exportData = value => {
      loadingExport.value = true;

      exportFile({
        endpoint: 'list-realisasi-export',
        payload: {
          month: filters.bulan,
          year: filters.tahun,
          entitas_id: filters.entitas,
          jenis_realisasi: value,
        },
        fileType: 'xlsx',
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        baseFileName: 'NKO',
        exportType: value,
        axiosInstance: axiosApi,
        entityOptions: options.entitas,
        onFinally: () => {
          loadingExport.value = false;
        },
      });
    };

    const exportDataPdf = value => {
      loadingExport.value = true;

      exportFile({
        endpoint: 'list-realisasi-export-pdf',
        payload: {
          month: filters.bulan,
          year: filters.tahun,
          entitas_id: filters.entitas,
          jenis_realisasi: value,
        },
        fileType: 'pdf',
        contentType: 'application/pdf',
        baseFileName: 'NKO',
        exportType: value,
        axiosInstance: axiosApi,
        entityOptions: options.entitas,
        onFinally: () => {
          loadingExport.value = false;
        },
      });
    };

    const deleteEvidence = () => {
      const accessToken = getItem('access_token');
      axiosApi
        .delete('list-realisasi-delete-evidence', {
          params: {
            month: bulan,
            year: tahun,
            entitas_id: entitas,
          },
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status == 200) {
            notification.success({
              message: 'Success',
              description: 'File berhasil dihapus',
            });
            refreshData();
          } else {
            notification.error({
              message: 'Error',
              description: 'Gagal menghapus file',
            });
          }
        })
        .catch(error => {
          console.error('Error deleting file:', error);
          notification.error({
            message: 'Error',
            description: error.response?.data?.message || error.message,
          });
        });
    };

    const download = async file => {
      try {
        const url = process.env.VUE_APP_API_BASE_URL + '/api/generate-download-url';
        // Step 1: Request pre-signed URL from backend
        // const response = await axios.post('http://localhost:8061/api/generate-download-url', {
        const response = await axiosApi.post(url, {
          path: file,
        });

        const downloadUrl = response.data;

        // Step 2: Open the pre-signed URL in a new tab
        window.open(downloadUrl, '_blank');
      } catch (error) {
        console.error('Error generating download URL:', error);
        notification.error({
          message: 'Error',
          description: 'Gagal mendapatkan URL untuk download file.',
        });
      }
    };

    onMounted(() => {
      dispatch('resetState');
      // Fetch entitas options directly from API
      axiosApi.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
      axiosApi
        .get('options-entitas')
        .then(response => {
          options.entitas = response.data;
        })
        .catch(error => {
          console.error('Error fetching entitas options:', error);
          notification.error({
            message: 'Gagal mengambil data entitas',
            description: error.message || 'Failed to fetch entitas options. Please try again.',
          });
        });
      if (entitas && tahun && bulan) {
        getData(entitas, tahun, bulan);
        getStatusApproval(entitas, tahun, bulan);
      }
    });

    // Using the utility function for checking approval status
    const checkStatusApproval = status => {
      checkStatusApprovalUtil(status, checkPermission, value => {
        isApproveVisible.value = value;
      });
    };

    const getStatusApproval = (entitas, tahun, bulan) => {
      axiosApi
        .get('realisasi-approval-status?month=' + bulan + '&year=' + tahun + '&entitas_id=' + entitas)
        .then(response => {
          if (response.data && response.data.length > 0) {
            approvalStatus.value = response.data[0].approval_status;
            if (response.data[0].nko_file && response.data[0].nko_file.length > 0) {
              file.value = response.data[0].nko_file[0].storage_location;
              filename.value = response.data[0].nko_file[0].title;
            } else {
              file.value = null;
              filename.value = '';
            }
          } else {
            approvalStatus.value = 'Proses Pengisian';
            file.value = null;
            filename.value = '';
          }
          checkStatusApproval(approvalStatus.value);
        })
        .catch(error => {
          console.error('Error fetching approval status:', error);
          notification.error({
            message: 'Gagal mengambil status approval',
            description: error.message || 'Failed to fetch approval status. Please try again.',
          });
        });
    };

    onBeforeRouteLeave(() => {
      store.commit('axiosResetState');
    });

    const rowClassName = record => {
      if (record.is_parent) {
        return 'table-row-minor';
      } else {
        return '';
      }
    };

    const getStatusApprovalColor = status => {
      switch (status) {
        case 'Proses Pengisian':
          return 'blue';
        case 'Menunggu Approval':
          return 'orange';
        case 'Approved':
          return 'green';
        case 'Uploaded Evidence':
          return 'volcano';
        default:
          return 'gray';
      }
    };

    return {
      options,
      filters,
      tahunOptions,
      rekapColumns,
      evidenceModal,
      uploadEvidence,
      beforeUpload,
      handleRemove,
      handleEvidenceOk,
      handleEvidenceCancel,
      saveAndApprove,
      refreshData,
      months,
      dataSource,
      isLoading,
      rowClassName,
      checkPermission,
      canManageApproval,
      profile,
      entitas,
      router,
      approvalStatus,
      file,
      filename,
      getStatusApprovalColor,
      loadingExport,
      exportData,
      loadingExportPdf,
      exportDataPdf,
      download,
      downloadProgress,
      isDownload,
      crud,
      isApproveVisible,
      handleDeleteEvidence,
      handleDeleteVerifikasi,
      handleDeleteRealisasi,
      getStatusApproval,
    };
  },
};
</script>

<style scoped>
.mb-25 {
  margin-bottom: 25px;
}

.mt-25 {
  margin-top: 25px;
}

.custom-icon {
  margin-left: 10px;
  color: rgb(54, 61, 68);
}

::v-deep(.table-row-minor) {
  background-color: #fada7a;
  font-weight: bold;
  font-size: 14px;
}

::v-deep .ant-table-thead > tr > th {
  background-color: #578fca; /* navy */
  color: white;
}
</style>
